<template>
  <div>
    <el-link
      type="primary"
      :underline="false"
      @click="handleClick"
      class="font-12"
      >{{ product.code || '-' }}</el-link
    >

    <!-- <router-link class="text-primary" :to="'/products/' + product.id">
      <slot v-if="$slots.content" name="content"></slot>
      <span v-else>{{ product.code }}</span>
    </router-link> -->

    <!-- <el-dialog
      :title="`${item.name}（${item.code}）历史记录信息`"
      :visible.sync="dialogVisible"
      width="1000px"
      :append-to-body="true"
    >
      <el-tabs>
        <el-tab-pane label="使用记录">
          <ItemRecords :item="item" :category="6" v-if="item.id"></ItemRecords>
        </el-tab-pane>
        <el-tab-pane label="维修检测记录">
          <ItemRecords
            :item="item"
            :hideAddBtn="true"
            :category="7"
            v-if="item.id"
          ></ItemRecords>
        </el-tab-pane>
        <el-tab-pane label="操作日志">
          <ItemRecords :item="item" v-if="item.id"></ItemRecords>
        </el-tab-pane>
      </el-tabs>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  props: {
    product: Object,
  },
  data: function () {
    return {
      dialogVisible: false,
    }
  },
  methods: {
    handleClick() {
      if (this.product.id) {
        let hasAuth = this.hasAuth(
          this.product.category == 1 ? 'productDetail' : 'instrumentDetail'
        )
        if (hasAuth) {
          this.$router.push(
            `/${this.product.category == 1 ? 'products' : 'instruments'}/` +
              this.product.id
          )
        }
      }
    },
  },
}
</script>